export default "__VITE_ASSET__9280a646__"